const contentHot = () => import('@/pages/content/hot/index.vue');

export default [{
    path: '/content/hot',
    component: contentHot,
    meta: [{
        name: '内容管理',
		activeRoute: '/content/manage'
    },
    {
        name: '热搜词管理',
        activeRoute: '/content/hot'
    }]
}];